import { PhPlugsConnected } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import { FeatureFlags } from '@/plugins/featureFlags'
import i18nPlugin from '@/plugins/i18n'

import {
  type IntegrationsSection,
  type IntegrationsSectionCreate,
  type IntegrationsSectionUpdate,
  type WebsiteResource,
} from '../../WebsiteBuilder.types'
import { websiteBlockMethods } from '../common/methods'

import IntegrationsEditor from './editor/IntegrationsEditor.vue'
import { createIntegrationsData } from './methods/createIntegrationsData'
import IntegrationsPreview from './preview/IntegrationsPreview.vue'

const i18n = i18nPlugin.global

export const WEBSITE_INTEGRATIONS_FLAG = 'hermes.websiteIntegrations'

export const IntegrationsBlockModule: BuilderBlockModule<
  IntegrationsSection,
  IntegrationsSectionCreate,
  IntegrationsSectionUpdate,
  WebsiteResource
> = {
  canAdd: () => FeatureFlags.isEnabled(WEBSITE_INTEGRATIONS_FLAG),
  createData: createIntegrationsData,
  editor: IntegrationsEditor,
  meta: [
    {
      icon: PhPlugsConnected,
      key: 'integrations',
      label: i18n.t('website-builder.blocks.integrations'),
    },
  ],
  methods: websiteBlockMethods,
  preview: IntegrationsPreview,
}
